import { Grid } from '@mui/material';
import React from 'react';
import { getDisplayValueForMaybeUndefinedValue } from '../../../../../../utils';
import { SingleColumnMainValue, SingleColumnSubValue } from '../common/utils';
import { SingleColumnFactboxSection } from './single-column-factbox-types';

/**
 * Calculate font scale factor based on number of subValues.
 * Use smaller font when there are many items to fit without scrolling.
 */
const getSubValuesFontScale = (subValuesCount: number): number => {
  return subValuesCount > 8 ? 0.75 : 1;
};

// Single column section component
export const SingleColumnSection = ({
  section,
}: {
  section: SingleColumnFactboxSection;
}) => {
  const subValuesCount = section.subValues?.length ?? 0;
  const fontScale = getSubValuesFontScale(subValuesCount);

  return (
    <Grid item container direction={'column'}>
      <Grid
        item
        container
        sx={{ flexGrow: 1 }}
        direction={'column'}
        alignItems={'center'}
      >
        {section.mainValue !== undefined && (
          <SingleColumnMainValue>
            {section.mainValue ?? '-'}
          </SingleColumnMainValue>
        )}
        {section.subValues && section.subValues.length > 0 ? (
          <Grid item container direction={'column'}>
            {section.subValues.map((subValue, i) => (
              <Grid
                key={`${subValue.title}-${i}`}
                item
                container
                direction={'row'}
                justifyContent={'space-between'}
                alignItems={'center'}
                wrap={'nowrap'}
              >
                <SingleColumnSubValue sx={{ fontSize: `${0.8 * fontScale}em` }}>
                  {getDisplayValueForMaybeUndefinedValue(subValue.title)}
                </SingleColumnSubValue>
                <SingleColumnSubValue
                  sx={{ flexShrink: 0, fontSize: `${0.8 * fontScale}em` }}
                >
                  {subValue.value}
                </SingleColumnSubValue>
              </Grid>
            ))}
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};
